import { defineAsyncComponent, reactive, toRaw } from "vue";
import i18n from "../.././i18n";
import { createLoading } from "../../utils/loading";
import { required, validateError } from "../../utils/validate";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { initUseForm } from "../../utils/form";
import { createFieldTextArea } from "../input/template-builder/template-builder.logic";
import { addModal } from "../../app.logic";
import lodash from "lodash";
import { modalStyleForm } from "../../utils/constant";

export const { isLoading, setIsLoading } = createLoading();

export const CancelForm = defineAsyncComponent(() => import("./CancelForm"));

export const openModalCancelForm = ({ props, onClick, title }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            okButtonProps: { disabled: false },
            title: title || i18n.global.t("button.cancel"),
            width: "500px",
            onOk: () => {
                refs.form.callOnClickModalOk().then((record) => {
                    if (onClick) {
                        onClick(record);
                    }
                    options.bind.onCancel();
                });
            },
            okType: "danger",
        }),
        render: () => (
            <CancelForm
                ref={(e) => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></CancelForm>
        ),
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        remark: null,
    };
};

export const createRules = () => {
    return {
        remark: [required],
    };
};

export const createField = ({ data }) => {
    const useForm = data.useForm;
    const modelRef = useForm.modelRef;
    return [
        createFieldTextArea({
            key: "remark",
            colProp: () => ({ xs: 24 }),
            label: () => i18n.global.t("views.remark.cancel"),
            inputProp: () => ({ value: modelRef.remark, "onUpdate:value": (value) => (modelRef.remark = value) }),
        }),
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then((page) => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
